export const STATUS_DROPDOWN = [
  { label: "Activate", value: "activate" },
  { label: "Deactivate", value: "deactivate" },
];

export const BLOG_STATUS_DROPDOWN = [
  { label: "Draft", value: "draft" },
  { label: "Published", value: "published" },
  { label: "Archived", value: "archived" },
];


export const VENDORS__TYPE_DROPDOWN = [
  {label:"Local",value:'local'},
  {label:"National",value:'national'},
  {label:"Affiliation",value:'affiliation'},
]
export const VENDORS__STATUS = [
  {label:"Active",value:true},
  {label:"De-active",value:false},
]